import { render, staticRenderFns } from "./AbkCheckboxQuestion.vue?vue&type=template&id=7b3d5fd2&scoped=true&"
import script from "./AbkCheckboxQuestion.vue?vue&type=script&lang=js&"
export * from "./AbkCheckboxQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AbkCheckboxQuestion.vue?vue&type=style&index=0&id=7b3d5fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3d5fd2",
  null
  
)

export default component.exports